import React from "react";

const ResultsCacheUpdateBanner = ({
  isUpdating = false,
  updateError = null,
  onRetry,
  updatingLabel,
}) => {
  if (updateError) {
    return (
      <div
        className="flex flex-col sm:flex-row sm:items-center gap-2 text-sm"
        role="alert"
        aria-live="assertive"
      >
        <p className="text-brand-muted">{updateError}</p>
        {onRetry ? (
          <button type="button" className="btn-brand self-start" onClick={onRetry}>
            Try again
          </button>
        ) : null}
      </div>
    );
  }

  if (!isUpdating) {
    return null;
  }

  return (
    <p
      className="flex items-center gap-2 text-sm text-brand-muted"
      role="status"
      aria-live="polite"
    >
      <span
        className="inline-block h-3 w-3 shrink-0 rounded-full border-2 border-brand-charcoal border-t-transparent animate-spin"
        aria-hidden="true"
      />
      {updatingLabel}
    </p>
  );
};

export default ResultsCacheUpdateBanner;
